import { render } from "./DualToneIcon.vue?vue&type=template&id=7612274b"
import script from "./DualToneIcon.vue?vue&type=script&lang=js"
export * from "./DualToneIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__